<template>
  <div class="about-page white-theme">
    <div class="container">
      <div class="page-header text-center">
        <span class="section-tag">{{ $t('about.tag') }}</span>
        <h1 class="section-title">{{ $t('about.title') }}</h1>
        <p class="section-subtitle">{{ $t('about.subtitle') }}</p>
      </div>
      <div class="about-body">
        <p v-for="(p, idx) in paragraphs" :key="'ap-' + idx">{{ p }}</p>
      </div>
      <div class="about-links">
        <router-link :to="navTo('TrustSafety')" class="btn btn-secondary">{{ $t('footer.trustSafety') }}</router-link>
        <router-link :to="navTo('Contact')" class="btn btn-primary">{{ $t('footer.contact') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  computed: {
    paragraphs: function () {
      var list = this.$t('about.paragraphs')
      return Array.isArray(list) ? list : []
    }
  },
  methods: {
    navTo: function (name) {
      var lang = this.$route.params.lang
      return lang ? { name: name, params: { lang: lang } } : { name: name }
    }
  }
}
</script>

<style scoped>
.about-page { padding: 48px 0 72px; }
.about-body {
  max-width: 720px;
  margin: 0 auto 32px;
  color: #4b5563;
  font-size: 15px;
  line-height: 1.75;
}
.about-body p { margin: 0 0 16px; }
.about-links {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
